import React, {useEffect} from "react";
import HorizontalScroll from "../UI/HorizontalScroll/HorizontalScroll";
import classes from "./Workouts.module.css";
import {string_to_slug as slug} from "../../store/utility"

const Workouts = (props) =>{
    // console.log(props)
    // useEffect(()=>{
    //     props.onFetchWorkoutPlans();
    // },[])
    // console.clear()
    var plan = props.plan; 
   
    let workouts = plan.workouts
    if(!workouts){
        return null
    }
    if(workouts.length<1){
        return null
    }
    // if(!(workouts.length > 1)){
    //     return null
    // }
    
    return(
       
        
        <div className={`container ${classes.HorizontalCarousel}`}>
        
                {
                    // plans.map(plan=>(
                    //     <>

                           
                    //     </>
                    // ))
                }
                
                <>
                <div className={classes.ItemContainer} >
                                <div className={classes.Item}>
                                    
                                        <div style={{maxHeight:"198px", overflow:"hidden"}}>
                                            <h5>{plan.title}</h5>
                                            <p>{plan.desc}</p>
                                        </div>
                                        <div>
                                            <a style={{color:"#FF8D1E"}} target="_blank" href={`/workouts/${slug(plan.title)}/${plan.id}`} >See All</a>
                                        </div>
                                        
                                    
                                    </div> 
                </div>
                            
             <HorizontalScroll workouts={plan.workouts} index={props.index}/>
                            
                </>
                
               
            </div>
             
       
       
         
    );
}
// const mapStateToProps = state=>{
//     return {
//         plans:state.workouts.workouts,
//         workoutsLoading:state.workouts.workoutsLoading
//     }
// }
// const mapDispatchToProps = dispatch=>{
//     return{
//         onFetchWorkoutPlans:()=>dispatch(actions.fetchWorkoutPlans())
//     }
// }
export default Workouts;